export default "__VITE_ASSET__29$lJRZ$__"